import { render, staticRenderFns } from "./AddAlertForTask.vue?vue&type=template&id=5eea27b8"
import script from "./AddAlertForTask.vue?vue&type=script&lang=js"
export * from "./AddAlertForTask.vue?vue&type=script&lang=js"
import style0 from "./AddAlertForTask.vue?vue&type=style&index=0&id=5eea27b8&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports